export default __webpack_public_path__ + "static/media/info-circle.3b6986d5.svg";